import { render, staticRenderFns } from "./LabelModal2.vue?vue&type=template&id=3e6c80bd&scoped=true&"
import script from "./LabelModal2.vue?vue&type=script&lang=js&"
export * from "./LabelModal2.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal2.vue?vue&type=style&index=0&id=3e6c80bd&prod&lang=scss&scoped=true&"
import style1 from "./LabelModal2.vue?vue&type=style&index=1&id=3e6c80bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c80bd",
  null
  
)

export default component.exports